import personalPhoto from "../assets/img/myphoto.jpg";
import resume from "../assets/CV-Mahmoud-Zanoun-Frontend-Developer.pdf";

export const Hero = () => {
  return (
    <section id="hero-h">
      <div className="container-h">
        <h2 className="h2-h">ABOUT ME</h2>
        <div className="hero-wrapper-h">
          <div className="col-h col-md-6 d-flex justify-content-center">
            <img
              src={personalPhoto}
              alt="personal pic"
              className="image-h img-fluid bg-white p-1 rounded-4 shadow image-600"
            />
          </div>
          <div className="col-h">
            <div className="text-wrapper-h">
              <p className="text-h mb-2-h">
                I've been working as a Frontend Developer for over three years now, mostly on real production stuff where we build web apps that can handle a lot of users with React.js and Next.js. Right now I'm at GenTech, and some of the bigger projects I've worked on include this internal talent marketplace called Adepti, then there's Taheiya which is a SaaS platform for accounting, and Science Toonz for education. It feels like those took a ton of effort to get right.
                <br />
                <br />
                I guess I focus a lot on TypeScript and things like state management with Redux or Zustand, React Query too, and making interfaces that work well on any device and run smoothly. I'm pretty into using AI tools to make the coding process faster, you know, and trying to create UI/UX that actually helps out millions of people, though sometimes it's hard to tell if it's exceptional until users say so.
                <br />
                <br />
                The tech stack I use most is React.js, Next.js, JavaScript, ES6, TypeScript, Redux, Zustand, React Query, plus MUI, Tailwind CSS and Shadcn/ui for styling, and testing with Jest or Vitest, along with CI/CD pipelines.
                <br />
                <br />
                That covers the main parts, I think, but there might be more details.
              </p>
              <a
                rel="noreferrer"
                target="_blank"
                className="btn-h"
                href={resume}
              >
                <span className="btn-item-h">View Resume</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
